import alt from '../alt';
import Immutable from 'seamless-immutable';
import {seamlessImmutable} from 'epic-alt-utils/index';

@seamlessImmutable
class ContributorStore {
    constructor() {
        this.on('error', (error) => {console.error(error);});
        this.state = Immutable({
            contributorsData: null
        });
    }
}

export default alt.createStore(ContributorStore, 'ContributorStore');
